var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "chat-modal",
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          )
            return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "c-sidesheet",
        { attrs: { active: _vm.active }, on: { close: _vm.close } },
        [
          _c(
            "div",
            { staticClass: "chat-modal__wrapper" },
            [
              _c("chat", {
                ref: "chat",
                staticClass: "chat-modal__content",
                attrs: {
                  entity: _vm.entity,
                  "entity-id": _vm.entityId,
                  "can-edit": _vm.canEdit,
                },
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }